module.exports = __webpack_public_path__ + "img/logo-dark.e5b49d42.svg";